"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

import { Link } from "@/navigation";

const IMAGE_BASE =
	"/image/new-version/casting/Metal-Casting/Metal-Casting-Services-for-Custom-Precision-Parts";

const CARDS = [
	{ key: "castingServicesCard1", image: `${IMAGE_BASE}/investment-casting.webp`, href: "/investment-casting" },
	{ key: "castingServicesCard2", image: `${IMAGE_BASE}/die-casting.webp`, href: "/die-casting" },
	{ key: "castingServicesCard3", image: `${IMAGE_BASE}/vacuum-casting.webp`, href: "/vacuum-casting" },
	{ key: "castingServicesCard4", image: `${IMAGE_BASE}/sand-casting.webp`, href: "/sand-casting" },
	{
		key: "castingServicesCard5",
		image: `${IMAGE_BASE}/low-pressure-die-casting.webp`,
		href: "/low-pressure-casting",
	},
	{
		key: "castingServicesCard6",
		image: `${IMAGE_BASE}/high-pressure-die-casting.webp`,
		href: "/high-pressure-casting",
	},
] as const;

export default function MetalCastingServices() {
	const t = useTranslations("new-metal-casting");

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<header className="mb-6 text-center sm:mb-8 md:mb-10 lg:mb-12">
					<h2 className="mb-3 text-2xl font-bold leading-tight text-black sm:mb-4 sm:text-[30px] md:text-4xl">
						{t("castingServicesTitle")}
					</h2>
					<p className="text-sm leading-relaxed text-black md:text-base">{t("castingServicesDesc")}</p>
				</header>

				<div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
					{CARDS.map((card) => (
						<article
							key={card.key}
							className="flex flex-col overflow-hidden rounded-xl border-2 border-[#7d7d7d] bg-white shadow-sm transition-shadow hover:shadow-md"
						>
							<div className="relative aspect-[4/2] w-full overflow-hidden bg-[#f5f5f5]">
								<Image
									src={card.image}
									alt={t(`${card.key}Alt`)}
									fill
									className="object-cover"
									sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
								/>
							</div>
							<div className="flex flex-1 flex-col px-3 py-5">
								<h3 className="mb-2 text-lg font-bold text-black sm:mb-3 sm:text-xl md:text-2xl">
									{t(`${card.key}Title`)}
								</h3>
								<p className="mb-4 flex-1 text-sm leading-relaxed text-black md:text-base">
									{t(`${card.key}Desc`)}
								</p>
							<div className="flex items-center justify-between gap-3">
								<Link
									href="/upload"
									className="inline-flex w-fit items-center justify-center rounded bg-themePrimary400 px-5 py-2 text-sm font-semibold text-white transition-all duration-300 hover:bg-[#83b751] hover:text-white"
								>
									{t("castingServicesGetQuote")}
								</Link>
								<Link
									href={card.href}
									className="inline-flex items-center gap-1 text-sm font-semibold text-themePrimary400 transition-colors duration-300 hover:text-[#83b751]"
								>
									{t("castingServicesLearnMore")}
									<span aria-hidden="true">↗</span>
								</Link>
							</div>
						</div>
						</article>
					))}
				</div>
			</div>
		</section>
	);
}
